import { render, staticRenderFns } from "./DefaultContent-RelatedProductsSwiper.vue?vue&type=template&id=2ca58530&"
import script from "./DefaultContent-RelatedProductsSwiper.vue?vue&type=script&lang=js&"
export * from "./DefaultContent-RelatedProductsSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports